<!--
 * @Author: awu
 * @Date: 2020-11-15 23:03:28
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 21:26:16
 * @Description: 名片夹
-->
<template>
    <div class="cardList">
        <HeadLine
            showEdit
            :subTitle="$t('userCenter').edit"
            :count="checkIds.length"
            :isEdit="isEdit"
            @click-edit="clickEdit"
            @click-cancel="clickCancel"
            @click-del="clickDel"
            @click-all="clickAll"
        >
            {{ userCenter.card }}</HeadLine
        >
        <div class="outside" v-if="!noData">
            <div class="box" v-for="item in lists" :key="item.id" @click="handleChoose(item)">
                <template v-if="isEdit">
                    <div class="box-bg"></div>
                    <div class="checked" v-if="checkIds.indexOf(item.id) > -1"></div>
                    <div class="unchecked" v-else></div>
                </template>
                <h2 :title="item.card.holder_info.name">
                    <img :src="item.card.holder_info.logo_url || require('@/assets/user/lt.png')" alt="" />
                    <p>{{ item.card.holder_info.name }}</p>
                </h2>
                <div class="line"></div>
                <p class="name" :title="item.card.holder_info.manager_name">{{  item.card.holder_info.manager_name }}</p>
                <p class="item">
                    <img src="../../assets/user/email.png" class="email-icon" alt="" />
                    <span :title="item.card.holder_info.email">
                        {{ userCenter.email + item.card.holder_info.email || "" }}
                    </span>
                </p>
                <p class="item">
                    <img src="../../assets/user/address.png" class="address-icon" alt="" />
                    <span :title="item.card.holder_info.address">{{ userCenter.address + item.card.holder_info.address || "" }}</span>
                </p>
                <p class="item">
                    <img src="../../assets/user/exhibit.png" class="exhibit-icon" alt="" />
                    <span :title="item.exhibition.base_info.data.cn.name">{{
                        userCenter.exhibition + item.exhibition.base_info.data.cn.name || ""
                    }}</span>
                </p>
            </div>
        </div>
        <Empty v-else :text="$t('tips').noCard" />
    </div>
</template>

<script>
import api from "@/api";
import HeadLine from "./components/HeadLine";
// import { exhibition_id } from "@/utils/exhibitId";
import Empty from "@/components/Empty";

export default {
    components: {
        Empty,
        HeadLine
    },
    data() {
        return {
            lists: [],
            isEdit: false,
            checkIds: [],
            noData: false
        };
    },
    methods: {
        handleChoose(item) {
            if (!this.isEdit) {
                return;
            }
            let index = this.checkIds.indexOf(item.id);
            if (index === -1) {
                this.checkIds.push(item.id);
            } else {
                this.checkIds.splice(index, 1);
            }
        },
        clickEdit() {
            this.isEdit = true;
        },
        clickCancel() {
            this.isEdit = false;
        },
        clickDel() {
            if (!this.checkIds.length) return;
            api.deleteCard(
                this.checkIds.join(",")
            ).then((res) => {
                if (res.res === 1) {
                    this.getCardList();
                    this.isEdit = false;
                    this.checkIds = [];
                }
            });
        },
        clickAll(flag) {
            if (flag) {
                this.checkIds = this.lists.map((item) => item.id);
            } else {
                this.checkIds = [];
            }
        },
        getCardList() {
            api.getCardList({}).then((res) => {
                if (res.res == 1) {
                    this.lists = res.cards || [];
                    this.isEdit = false;
                    this.checkIds = [];
                    // this.noData = !this.lists.length;
                }
            });
        }
    },
    mounted() {
        this.getCardList();
    },
    computed: {
        userCenter() {
            return this.$t("userCenter");
        }
    }
};
</script>

<style lang="scss" scoped>
.cardList {
    padding-top: 40px;
    font-size: 14px;
    .outside {
        padding-left: 10px;
        padding-top: 20px;
        .box {
            display: inline-block;
            vertical-align: middle;
            margin-right: 33px;
            width: 34%;
            background: #ffffff;
            box-shadow: 0px 6px 17px 0px rgba(34, 38, 56, 0.2);
            border-radius: 5px;
            margin-bottom: 20px;
            padding: 0 13px 6px;
            position: relative;
            overflow: hidden;
            .box-bg {
                background: rgba(216, 216, 216, 0.7);
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
            }
            .checked {
                width: 15px;
                height: 15px;
                border-radius: 13px;
                position: absolute;
                left: 13px;
                top: 11px;
                z-index: 1;
                background: #ea6767 url("~@/assets/user/confirm.png") no-repeat center;
                background-size: contain;
            }
            .unchecked {
                width: 15px;
                height: 15px;
                border-radius: 13px;
                position: absolute;
                left: 13px;
                top: 11px;
                z-index: 1;
                border: 1px solid rgba(0, 0, 0, 0.45);
            }
            > h2 {
                width: 100%;
                color: rgba(9, 70, 140, 1);
                word-break: break-all;
                padding: 11px 0;
                font-size: 12px;
                display: flex;
                align-items: center;
                > p {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    height: 14px;
                    line-height: 15px;
                }
                > img {
                    max-width: 16px;
                    margin-right: 4px;
                }
            }
            .line {
                width: 100%;
                height: 1px;
                background-color: rgba(0, 0, 0, 0.09);
            }
            .name {
                margin-top: 7px;
                font-weight: 500;
                color: rgba(9, 70, 140, 0.79);
                margin-bottom: 7px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .item {
                width: 100%;
                height: 14px;
                display: flex;
                align-items: center;
                font-size: 8px;
                font-weight: 400;
                color: #5f7185;
                line-height: 14px;
                margin-bottom: 8px;
                > img {
                    margin-right: 7px;
                }
                > span {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                    display: block;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/cardList.vue